/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryNature extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryNature");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryNature.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryNature>): AssessmentViewQueryNature {
        let obj = Object.assign(new AssessmentViewQueryNature(), model);
        AssessmentViewQueryNature.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryNature>): AssessmentViewQueryNature {
        if (!model) return null;
        return AssessmentViewQueryNature.newInstance(<AssessmentViewQueryNature> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryNature) {
        if (!obj) return;

        models.AssessmentViewQueryNature.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryNature): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryNature.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Nature of the best practice
     */
    natures: Array<models.WellArchitectedFrameworkBestPracticeNature>;

}
